// extracted by mini-css-extract-plugin
module.exports = {"comingSoonContainer":"OrdersSection_comingSoonContainer__Z9W9L","topBar":"OrdersSection_topBar__m_cLF","titleText":"OrdersSection_titleText__g00a9"};